export enum ReportType {
  SUMMARY = 'summary',
  DETAIL = 'detail'
}

export interface ReportQueryParams {
  inverted?: boolean;
}
